import { DocumentReference } from "firebase/firestore";
import Link from "next/link";
import React from "react";
import { HiOutlineEye } from "react-icons/hi";
import ReactTooltip from "react-tooltip";
import { Pack } from "../../firebase/firestore";
import { useAuth } from "../../hooks/useAuth";
import { AggregatedViews, useObjectViews } from "../../hooks/useObjectViews";
import { prettyDate } from "../../utils/dates";
import { composePrivateLink, composePublicLink } from "./PackPage";

export type PackViewsProps = {
  packRef: DocumentReference;
  pack: Pack;
};

function ViewerRow({ viewer, date, ...rest }) {
  return (
    <div className="flex my-2 items-center text-white text-sm">
      <div className={` w-52  break-all ${!viewer?.nickname && "text-light-gray "}`}>
        {viewer.nickname ? `@${viewer.nickname}` : "Non-beatpacks user"}
      </div>
      <div className="text-xs opacity-60 text-light-gray">{prettyDate(date.toDate ? date.toDate() : date)}</div>
    </div>
  );
}

const SeeAsReceiver = ({ pack, canEdit, user, ...rest }) =>
  canEdit ? (
    <div {...rest}>
      <Link
        href={{
          pathname: pack.publicLink
            ? composePublicLink(pack.creator || user, pack.publicLink)
            : composePrivateLink(pack.creator || user, pack.private_link.value, true),
          query: { asReceiver: true },
        }}
      >
        <span>See pack as receiver</span>
      </Link>
    </div>
  ) : null;

export default function PackViews({ pack, packRef, ...rest }: PackViewsProps) {
  const { loading, views } = useObjectViews(packRef, "pack");

  const { user } = useAuth();
  return <PackViewsPure loading={loading} pack={pack} views={views} user={user} />;
}

export function PackViewsPure({ loading, views, user, pack = null, ...rest }) {
  const viewsNum = views?.viewers?.length;
  return (
    <div className={`${loading ? "opacity-0" : "opacity-100"} min-w justify-center transition-opacity`} {...rest}>
      <span className="flex cursor-default items-center justify-center min-w " data-for="views-tooltip" data-tip={""}>
        <HiOutlineEye color="white" className="text-white mr-2 w-4 h-4 " />
        <span>{viewsNum > 0 ? `viewed by ${views?.viewers?.length}` : `no views yet`}</span>
      </span>
      <ReactTooltip
        delayHide={100}
        delayShow={100}
        id="views-tooltip"
        className="max-h-64 py-6 overflow-auto"
        delayUpdate={500}
        place="bottom"
        effect="solid"
        getContent={() =>
          views && (
            <div className="relative" style={{ minWidth: 150 }}>
              {viewsNum > 0 ? (
                views.viewers
                  .sort((v1, v2) => (views.last_dates[v1.uid] < views.last_dates[v2.uid] ? 1 : -1))
                  .map((viewer) => <ViewerRow viewer={viewer} date={views.last_dates[viewer.uid]} />)
              ) : (
                <span>Time to share your pack!</span>
              )}
              {user && pack && (
                <SeeAsReceiver
                  className="text-right opacity-40 mt-4 text-xs hover:underline cursor-pointer"
                  pack={pack}
                  canEdit={true}
                  user={user}
                />
              )}
            </div>
          )
        }
      />
    </div>
  );
}
